import { createSlice } from '@reduxjs/toolkit';
import { fetchPermiss } from '../action/permissesAction';
const initialState = {
    permiss: {
        topic: false,
        exercise: false
    },
    isLoaderPerm: false
};
export const permSlice = createSlice({
    initialState,
    name: 'permiss',
    reducers: {},
    extraReducers: {
        [fetchPermiss.fulfilled.type]: (state, action) => {
            state.permiss = action.payload || { topic: false, exercise: false };
            state.isLoaderPerm = false;
        },
        [fetchPermiss.pending.type]: (state) => {
            state.isLoaderPerm = true;
        }
    }
});
export default permSlice.reducer;
